import React from 'react';

/** Circular friend / requester photo or initial fallback. */
export default function FriendAvatar({ photoURL, name }) {
  if (photoURL) {
    return <img className="friend-avatar" src={photoURL} alt="" />;
  }
  const initial = (name || '?').trim().charAt(0).toUpperCase() || '?';
  return (
    <span className="friend-avatar friend-avatar--fallback" aria-hidden="true">
      {initial}
    </span>
  );
}
